import React, { useState } from "react";
import { Form, H4 } from "../../Styles/Global.Styled";
import { css } from "styled-components";
import {
  getFormComponent,
  getPhoneNoFormComp,
  processFormData,
} from "../../helpers/formHandlers";
import { Toast } from "../../Components/Toast/Toast";
import useToast from "../../hooks/useToast";
import { addNewUser } from "../../api/user";
import FormSubmissionBttn from "../../Components/Buttons/FormSubmissionBttn";

const formStyle = css`
  gap: 1vh;
  row-gap:2vh;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: row;
  width: 30%;
  flex-wrap: wrap;
  border-radius: 12px;
  box-shadow: 0 0 2px 1px grey;
  padding: 1vh 2vh;
`;
const widthStyle = css`
  width: 100%;
  box-shadow: none;
`;
const h4Style = css`
  width: 100%;
  font-size: 1.5vh;
  font-weight: 600;
  margin-bottom: -.5vh;
`;

const RegisterForm = ({ formData, setForm, setStep }) => {
  const [isLoading, setLoading] = useState(false);
  const { toast, showToast, hideToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const processedData = processFormData(formData);
      if (processedData.errors === true) {
        const firstError = processedData.formErrors[0];
        showToast({
          title: `${firstError.label}`,
          text: `${firstError.errors}`,
          type: "Error",
        });
        return;
      }

      await addNewUser(processedData);
      showToast({
        title: "Success:",
        text: `You have been registered successfully`,
        type: "Success",
      });
      setStep((prev) => prev + 1);
    } catch (error) {
      showToast({
        title: "Unexpected error",
        text: `${error.message}`,
        type: "Error",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderFields = (start, end) =>
    formData
      .slice(start, end)
      .map((props, index) =>
        getFormComponent({ props, setForm, index: index + start })
      );

  return (
    <Form
      encType="multipart/form-data"
      $baseStyle={formStyle}
      $mStyle={widthStyle}
      onSubmit={(e) => handleSubmit(e)}
    >
      {!toast.hidden && (
        <Toast
          top="0"
          message={toast.text}
          title={toast.title}
          type={toast.type}
          position={"sticky"}
          height={"5vh"}
          hideToast={hideToast}
        />
      )}
      <H4 $baseStyle={h4Style}>Company details</H4>
      {renderFields(6, 8)}
      <H4 $baseStyle={h4Style}>Account manager</H4>
      {renderFields(0, 2)}
      {getPhoneNoFormComp(formData[2], formData[3], setForm, 2, 3)}
      <H4 $baseStyle={h4Style}>Login credentials</H4>
      {renderFields(4, 6)}
      <H4 $baseStyle={h4Style}>Address</H4>
      {renderFields(8, 14)}
      <FormSubmissionBttn text="Register" isLoading={isLoading}/>
    </Form>
  );
};

export default RegisterForm;
